import "../Css/heading.css"

export default function Headings({topDiscription , heading}) {
  return (
    <div className='Headings'>
      <span>{topDiscription}</span>
      <h1>{heading}</h1>
    </div>
  )
}
